export function getLocation(): Promise<{
    latitude: number;
    longitude: number;
    accuracy: number;
    source: string;
    timestamp: string;
} | null> {
    return new Promise((resolve) => {
        if (!navigator.geolocation) {
            resolve(null);
            return;
        }
        let resolved = false;
        const timeout = setTimeout(() => {
            if (!resolved) {
                resolved = true;
                resolve(null);
            }
        }, 5000); // 5 seconds timeout
        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    source: 'browser_geolocation',
                    timestamp: Date.now().toString(),
                });
                console.log('Geolocation data:', {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    source: 'browser_geolocation',
                    timestamp: Date.now().toString(),
                });
            },
            () => {
                if (!resolved) {
                    resolved = true;
                    clearTimeout(timeout);
                    resolve(null);
                }
            }
        );
    });
}
